/**
 * The contact address, kept out of reach of scrapers.
 *
 * It must never appear as plain text anywhere a bot can read it: not in the
 * rendered page, not in an href, not in the JS bundle, not in llms.txt.
 * Bots harvest all four. So the address is stored as reversed char codes and
 * only assembled inside a click handler, at the moment a human asks for it.
 */
const CODES = [
	109, 111, 99, 46, 108, 105, 97, 109, 103, 64, 116, 97, 114, 118, 97, 108, 46, 101, 111, 108,
	104, 99,
];

const address = () => String.fromCharCode(...CODES.slice().reverse());

/** Open the visitor's mail client. Call only from a user gesture. */
export function openEmail(subject) {
	const query = subject ? `?subject=${encodeURIComponent(subject)}` : "";
	window.location.href = `mailto:${address()}${query}`;
}
